// ✅ DOT SLIDER CONFIG
export const slickDot = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  responsive: [
    { breakpoint: 800, settings: { slidesToShow: 1 } },
    { breakpoint: 993, settings: { slidesToShow: 1 } },
    { breakpoint: 580, settings: { slidesToShow: 1 } },
    { breakpoint: 481, settings: { slidesToShow: 1 } }
  ]
};

// ✅ ✅ ONLY ONE BannerActivation (AUTO SCROLL 0.3 SEC ADDED)
export const BannerActivation = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,

  autoplay: true,

  autoplaySpeed: 4000, // ✅ 4 seconds between each slide (SLOW & PERFECT)
  speed: 1200,         // ✅ 1.2 seconds smooth transition animation

  pauseOnHover: false
};

